(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-brands"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ad-brand-browser'))customElements.define('ad-brand-browser',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.department='all';
    const input=this.querySelector('[data-brand-search]');
    const filter=()=>{
      const query=input.value.trim().toLocaleLowerCase();let total=0;
      this.querySelectorAll('[data-brand-department]').forEach(group=>{
        let visible=0;
        group.querySelectorAll('[data-brand-letter]').forEach(letter=>{
          let count=0;letter.querySelectorAll('[data-brand-name]').forEach(item=>{item.hidden=!item.dataset.brandName.includes(query);if(!item.hidden)count++});letter.hidden=count===0;visible+=count;
        });group.hidden=visible===0||(this.department!=='all'&&group.dataset.brandDepartment!==this.department);if(!group.hidden)total+=visible;
      });this.querySelector('[data-brand-empty]').hidden=total>0;
    };
    input.addEventListener('input',filter);
    this.querySelectorAll('[data-department]').forEach(button=>button.addEventListener('click',()=>{this.department=button.dataset.department;this.querySelectorAll('[data-department]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));filter()}));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-flagship-connect"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wireSignup = (root) => {
    if (!root || root.dataset.ready || !root.dataset.company || !root.dataset.list) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const status = root.querySelector('[role=status]');
    const button = form.querySelector('button[type=submit]');
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || form.getAttribute('aria-busy') === 'true') return;
      const email = form.querySelector('input[type=email]').value.trim();
      const interests = [...form.querySelectorAll('input[name=ad_interests]:checked')].map(input => input.value);
      const attributes = { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (interests.length) attributes.properties = { Adilsons_Interests: interests };
      const body = { data: { type: 'subscription', attributes: { custom_source: 'Adilsons flagship homepage', profile: { data: { type: 'profile', attributes } } }, relationships: { list: { data: { type: 'list', id: root.dataset.list } } } } };
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      status.textContent = root.dataset.loading;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(root.dataset.company), { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' }, body: JSON.stringify(body), signal: controller.signal });
        if (!response.ok) throw new Error('Subscription failed');
        status.textContent = root.dataset.success;
        form.reset();
      } catch (error) { status.textContent = root.dataset.error; }
      finally { clearTimeout(timeout); form.removeAttribute('aria-busy'); button.disabled = false; }
    });
  };
  document.querySelectorAll('[data-ad-signup]').forEach(wireSignup);
  document.addEventListener('shopify:section:load', event => wireSignup(event.target.querySelector('[data-ad-signup]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-flagship-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ad-flagship-navigation')) {
  const wireAdHeader = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const departments = [...root.querySelectorAll('.adf-department')];
    const viewport = window.matchMedia('(min-width: 750px)');
    const menuRoot = root.querySelector('.adf-mobile-root');
    menuRoot.open = viewport.matches;
    viewport.addEventListener('change', event => { menuRoot.open = event.matches; });
    const close = (details, focus) => { details.open = false; if (focus) details.querySelector('summary').focus(); };
    departments.forEach(details => {
      details.addEventListener('toggle', () => { if (details.open) departments.forEach(other => { if (other !== details) close(other, false); }); });
      details.querySelector('.adf-menu-close').addEventListener('click', () => close(details, true));
    });
    root.addEventListener('keydown', event => { if (event.key === 'Escape') { const open = departments.find(d => d.open); if (open) { close(open, true); event.preventDefault(); } else if (!viewport.matches) { menuRoot.open = false; } } });
    document.addEventListener('click', event => { if (root.isConnected && !root.contains(event.target)) departments.forEach(d => close(d, false)); });
    document.addEventListener('focusin', event => { if (root.isConnected && !root.contains(event.target)) departments.forEach(d => close(d, false)); });
  };
  document.querySelectorAll('[data-ad-header]').forEach(wireAdHeader);
  document.addEventListener('shopify:section:load', event => wireAdHeader(event.target.querySelector('[data-ad-header]')));
}

if(!customElements.get('ad-predictive-search'))customElements.define('ad-predictive-search',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.input=this.querySelector('input[name=q]');this.panel=this.querySelector('.ad-search-results');this.status=this.querySelector('[data-search-status]');this.sequence=0;this.index=-1;this.events=new AbortController();const signal=this.events.signal;
  this.input.addEventListener('input',()=>{clearTimeout(this.timer);this.controller?.abort();this.sequence++;this.close();if(this.input.value.trim().length>1)this.timer=setTimeout(()=>this.search(),220)},{signal});
  this.input.addEventListener('keydown',e=>{const options=[...this.panel.querySelectorAll('[role=option]')];if(e.key==='Escape'){e.stopPropagation();this.sequence++;this.controller?.abort();clearTimeout(this.timer);this.close();return}if(this.panel.hidden)return;if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();this.index=(this.index+(e.key==='ArrowDown'?1:-1)+options.length)%options.length;options.forEach((a,i)=>a.setAttribute('aria-selected',String(i===this.index)));const active=options[this.index];if(active){this.input.setAttribute('aria-activedescendant',active.id);active.scrollIntoView({block:'nearest'})}}else if(e.key==='Enter'&&this.index>=0){e.preventDefault();options[this.index].click()}},{signal});
  this.addEventListener('focusout',()=>{setTimeout(()=>{if(!this.contains(document.activeElement)){this.sequence++;this.controller?.abort();clearTimeout(this.timer);this.close()}},0)},{signal});
  this.input.addEventListener('focus',()=>{if(this.input.value.trim().length>1)this.search()},{signal});
 }
 close(){this.panel.hidden=true;this.input.setAttribute('aria-expanded','false');this.input.removeAttribute('aria-activedescendant');this.index=-1;this.status.textContent=''}
 async search(){const query=this.input.value.trim();if(query.length<2)return;const sequence=++this.sequence;this.controller?.abort();this.controller=new AbortController();this.status.textContent=this.status.dataset.loading;
  try{const url=new URL(this.dataset.url,location.origin);url.search=new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'6',section_id:'ad-predictive-results'});const response=await fetch(url,{signal:this.controller.signal});if(!response.ok)throw new Error('Search unavailable');const html=await response.text();if(sequence!==this.sequence)return;const doc=new DOMParser().parseFromString(html,'text/html');const list=doc.querySelector('[role=listbox]');if(!list){this.close();return}this.panel.replaceChildren(list);this.panel.querySelectorAll('[role=option]').forEach((a,i)=>a.id=this.panel.id+'-'+i);this.panel.hidden=false;this.input.setAttribute('aria-expanded','true');this.status.textContent='';}
  catch(error){if(sequence===this.sequence)this.close()}
 }
 disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();this.events?.abort();this.ready=false}
});
const adStickyHeader=()=>{const header=document.querySelector('[data-ad-header]');if(header)header.classList.toggle('ad-is-scrolled',window.scrollY>120)};
window.addEventListener('scroll',adStickyHeader,{passive:true});adStickyHeader();
window.addEventListener('cartcount:update',event=>{const count=event.detail?.item_count;if(typeof count!=='number')return;document.querySelectorAll('[data-ad-cart]').forEach(link=>{link.querySelector('span').textContent=String(count);link.setAttribute('aria-label',link.dataset.countLabel.replace('__COUNT__',String(count)))});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
